import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseServiceFacade, GenericApiCall } from '../../../common/store/types';
import { AppState } from '../types';
import { ListItem } from '../typeahead/types';
import { groupActions } from './group.actions';
import { groupSelectors } from './group.selector';

@Injectable()
export class GroupService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }

  getListItem: GenericApiCall<ListItem[], void> = this.genericApiCall(
    groupActions.getListItem,
    groupSelectors.getListItem,
    true,
  );
}
